<template>
  <footer class="footer-message">
    {{ title || '*本次会议为非公开会议，仅限于受邀请的特定人士参加。未经高毅资产书面同意，请勿对外转发或展示本邀请函，感谢您的理解与支持。' }}
  </footer>
</template>

<script>
export default {
  name: "footer-message",
  props: ['title'],
}
</script>

<style lang="less">
.footer-message {
  width: 100vw;
  text-align: center;
  font-size: 12px;
  //font-weight: bold;
  position: fixed;
  bottom: 15px;
  left: 50%;
  z-index: 2;
  transform: translate(-50%, 0) scale(0.9);
  color: #999;
}
</style>
